import React from 'react';
import { useTranslation } from 'react-i18next';
import { isMobileOnly } from 'react-device-detect';

const RemoveDunningsMenu = ({ goToAll, goToSelective, handleClose }) => {
    const { t } = useTranslation();

    return (
        <div className="wrapper w-100 d-flex gap-4 flex-column h-auto">
            <div className="modal_container__body__text" style={{ maxWidth: 500 }}>
                {t('Choose an option to remove dunnings')}
            </div>

            <div className="modal_container__body__row-modal d-flex flex-column gap-3">
                <button
                    className={`button_red_small__admin w-100 ${isMobileOnly ? 'mobile' : ''}`}
                    onClick={goToAll}
                >
                    {t('Remove all dunnings')}
                </button>

                <button
                    className={`button_red_small__admin w-100 ${isMobileOnly ? 'mobile' : ''}`}
                    onClick={goToSelective}
                >
                    {t('Remove selected dunnings')}
                </button>

                <button
                    className={`button_red_small ${isMobileOnly ? 'mobile' : ''}`}
                    onClick={handleClose}
                >
                    {t('Cancel')}
                </button>
            </div>
        </div>
    );
};

export default RemoveDunningsMenu;
